import styled from 'styled-components';

export default styled.div`
	--gap: var(--spacing-x-large);
	padding: var(--gap);
	gap: var(--gap);
	display: flex;
	flex-direction: column;

	.list {
		display: flex;
		flex-direction: column;
		gap: var(--spacing-medium-small);
	}
`;
